// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { qrCodeButtonStyles } from "@bg/App/Widgets/ProductDetails/ProductDetailsQrCode";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

qrCodeButtonStyles.qrCodeButton = {
    css: css`
        display: flex;
        align-items: center;
        padding: 0 12px;
        white-space: nowrap;
        ${IconWrapper} {
            margin-right: 5px;
        }
    `,
};
